import { render, staticRenderFns } from "./DashboardWidgetVorgaenge.vue?vue&type=template&id=1bd49f4c&scoped=true"
import script from "./DashboardWidgetVorgaenge.vue?vue&type=script&lang=js"
export * from "./DashboardWidgetVorgaenge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd49f4c",
  null
  
)

export default component.exports